import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useMemo } from 'react';
import { DayProps } from './Day.types';
import { COLORS, FONTS } from '../../../../constants';
import dayjs from 'dayjs';

const Day: FC<DayProps> = ({
  current,
  date,
  initDate,
  onPress,
  emptyDate = false,
  beginDate,
  endDate,
}) => {
  const fullDate = useMemo(() => {
    if (date && current) {
      const day = date < 10 ? `0${date}` : date.toString();
      const fullDate = `${dayjs(current).format('YYYY-MM')}-${day}`;
      return fullDate;
    } else return '';
  }, [date, current]);
  const currentDate = dayjs(new Date()).format('YYYY-MM-DD');

  const isRangeDate = useMemo(() => {
    let result = false;

    if (
      beginDate &&
      endDate &&
      beginDate < new Date(fullDate) &&
      endDate > new Date(fullDate)
    ) {
      result = true;
    }

    return result;
  }, [beginDate, endDate, fullDate]);
  const handleSelectDate = () => {
    if (onPress) onPress(fullDate);
  };

  if (emptyDate) {
    return (
      <Text style={[styles.dayButton, { backgroundColor: COLORS.WHITE }]} />
    );
  }

  if (initDate && initDate === fullDate) {
    return (
      <TouchableOpacity
        style={[
          styles.dayButton,
          {
            backgroundColor: COLORS.RED_PRIMARY,
          },
        ]}
        onPress={handleSelectDate}
      >
        <Text style={[styles.dayText, { color: COLORS.WHITE }]}>{date}</Text>
      </TouchableOpacity>
    );
  }

  if (
    (beginDate &&
      dayjs(new Date(beginDate)).format('YYYY-MM-DD') === fullDate) ||
    (endDate && dayjs(new Date(endDate)).format('YYYY-MM-DD') === fullDate)
  ) {
    return (
      <TouchableOpacity
        style={[
          styles.dayButton,
          {
            // backgroundColor: '#e0515c',
            backgroundColor: COLORS.RED_PRIMARY,
          },
        ]}
        onPress={handleSelectDate}
      >
        <Text style={[styles.dayText, { color: COLORS.WHITE }]}>{date}</Text>
      </TouchableOpacity>
    );
  }

  return (
    <TouchableOpacity
      style={[
        styles.dayButton,
        currentDate === fullDate && { backgroundColor: COLORS.WHITE },
        isRangeDate && { backgroundColor: COLORS.LIGHT_RED },
      ]}
      onPress={handleSelectDate}
    >
      <Text
        style={[
          styles.dayText,
          currentDate === fullDate && { color: COLORS.RED_PRIMARY },
        ]}
      >
        {date}
      </Text>
    </TouchableOpacity>
  );
};

export default Day;

const styles = StyleSheet.create({
  dayButton: {
    flex: 1,
    height: 33,
    padding: 4,
    backgroundColor: COLORS.WHITE,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dayText: {
    fontSize: 13,
    fontFamily: FONTS.AvenirMedium,
    textTransform: 'uppercase',
    color: COLORS.DARKER_GREY,
    textAlign: 'center',
  },
});
